// extracted by mini-css-extract-plugin
export default {"base-button-wrapper":"configurator-web-base-button-wrapper"};